// extracted by mini-css-extract-plugin
module.exports = {"container":"ShopReviewKeywords_container__cXWxw","item":"ShopReviewKeywords_item__Pr381","showAllButton":"ShopReviewKeywords_showAllButton__JwWhX"};